/**
 * sso-login Phase 1 — the frozen wire contract for "Sign in with Microsoft / Google"
 * (docs/plans/sso-login-master-plan.md § Wire contract). The API and the web app both
 * import it; the exchange response is the existing login shape `{ user, accessToken,
 * refreshToken }`, so it is not repeated here.
 */

/** The `:provider` path segment of `/api/v1/auth/sso/:provider/*`. */
export type SsoProviderId = 'microsoft' | 'google';

/** `GET /api/v1/auth/sso/providers` — only providers whose client id and secret are configured. */
export interface SsoProvidersResponse {
  providers: SsoProviderId[];
}

/**
 * Error codes an SSO sign-in can end with. The callback carries one to the web app as
 * `/login?sso_error=<CODE>`; `SSO_REQUIRED` is the 403 code on a blocked admin password login.
 */
export const SSO_ERROR_CODES = {
  NO_ACCOUNT: 'SSO_NO_ACCOUNT',
  EMAIL_NOT_VERIFIED: 'SSO_EMAIL_NOT_VERIFIED',
  ACCOUNT_INACTIVE: 'SSO_ACCOUNT_INACTIVE',
  ADMIN_MICROSOFT_REQUIRED: 'SSO_ADMIN_MICROSOFT_REQUIRED',
  ADMIN_WRONG_TENANT: 'SSO_ADMIN_WRONG_TENANT',
  PERSONAL_ACCOUNT: 'SSO_PERSONAL_ACCOUNT',
  PROVIDER_ERROR: 'SSO_PROVIDER_ERROR',
  EXPIRED: 'SSO_EXPIRED',
  SSO_REQUIRED: 'SSO_REQUIRED',
} as const;

export type SsoErrorCode = (typeof SSO_ERROR_CODES)[keyof typeof SSO_ERROR_CODES];
